import React, { useEffect, useCallback, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { showToast } from "../../utils/utils";
import useXeroApi from "../../hooks/useXeroApi";
import useMixpanelEventAction from "../../config/mixpanel/useMixpanelEventAction";
import useGA4EventAction from "../../config/GoogleAnalytics/useGA4EventAction";
import { callBackComp, invcsConnect } from "../../locales/en";
import { showToastType } from "../../utils/constants/appConstants";
import { INVOICE } from "../../route/paths";

const XeroCallBack = () => {
  const navigate = useNavigate();
  const initialRender = useRef(true);
  const { XeroCallBack } = useXeroApi();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const codeParams = queryParams.get("code");
  const { xeroConnectMixpanelEvent } = useMixpanelEventAction();
  const { xeroConnectGA4Event } = useGA4EventAction();

  const handleXeroCallBack = useCallback(async () => {
    try {
      const response = await XeroCallBack({
        code: codeParams
      });

      await xeroConnectGA4Event();
      if (!response.data.data.BookIdDetails) {
        xeroConnectMixpanelEvent();
        showToast(callBackComp.xeroCall.text, showToastType.success);
      }

      navigate(INVOICE, {
        state: {
          BookIdDetails: response.data.data.BookIdDetails
            ? response.data.data.BookIdDetails
            : null,
          softwareType: "XERO",
          autoSyncInvoice: true
        }
      });
    } catch (err) {
      navigate(INVOICE);
      console.error(invcsConnect.errMsg.item1, err);
    }
  }, [
    XeroCallBack,
    codeParams,
    navigate,
    xeroConnectMixpanelEvent,
    xeroConnectGA4Event
  ]);

  useEffect(() => {
    if (initialRender.current) {
      handleXeroCallBack();
      initialRender.current = false;
    }
  }, [handleXeroCallBack]);

  return <h5 className="text-dark">{callBackComp.doNotRefresh} </h5>;
};

export default XeroCallBack;
